import { render } from "./deals-kanban.vue?vue&type=template&id=979eac60"
import script from "./deals-kanban.vue?vue&type=script&lang=js"
export * from "./deals-kanban.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__